import styled from 'styled-components';
import {IoCalendarOutline} from 'react-icons/io5';

interface Props {
  active?: boolean;
  hover?: boolean;
  last?: boolean;
  first?: boolean;
}

export const Container = styled.div`
  height: 30px;
  border-radius: 8px;
  z-index: 190;
  background-color: white;

  display: flex;
  align-self: flex-start;
`;

export const Option = styled.div<Props>`
  position: relative;
  height: 100%;
  padding: 0 10px;
  cursor: pointer;
  transition: all ease-in-out 0.2s;
  background-color: ${(props) => props.active && props.theme.colors.softGray};
  font-size: 12px;
  color: ${(props) =>
    props.active ? props.theme.colors.darkGray : props.theme.colors.opaqueText};
  font-weight: 600;

  display: flex;
  gap: 5px;
  align-items: center;
  z-index: 1000;
  border-right: 1px solid ${(props) => props.theme.colors.softBorder};

  ${(props) =>
    props.first &&
    `
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
  `}

  ${(props) =>
    props.last &&
    `
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-right: none;
  `}

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.primaryLight};
    transition: all ease-in-out 0.2s;

    svg {
      color: ${(props) => props.theme.colors.primary};
    }
  }

  ${(props) =>
    props.hover &&
    `
      color: ${props.theme.colors.primary};
      background-color: ${props.theme.colors.primaryLight};
      transition: all ease-in-out 0.2s;

      svg {
        color: ${props.theme.colors.primary};
      }
  `}

  label {
    text-transform: capitalize;
    font-size: 12px;
    color: ${(props) =>
      props.active
        ? props.theme.colors.darkGray
        : props.theme.colors.opaqueText};
    font-weight: 600;
  }
`;

export const CalendarIcon = styled(IoCalendarOutline)<Props>`
  font-size: 18px;
  color: ${(props) => props.theme.colors.opaqueText};
  transition: all ease-in-out 0.2s;
  background-color: transparent;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const HoverButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 25px;
  padding: 0 5px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.primaryLight};
    transition: all ease-in-out 0.2s;

    svg {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;
